import styled from "styled-components";

export const ModalWrapper = styled.div`
  /* Custom styles for modal height - 80% of viewport */
  /* The Modal component from @ann/web-components will be rendered inside this wrapper */
  /* We'll use CSS to target the modal's root element */
  
  /* Note: Since Modal renders in a portal, we may need to use global styles or 
     pass className to Modal if it supports it. For now, width is handled via prop. */
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 60vh; /* Ensure content area takes up space */
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  padding: 16px 0;
`;

export const ActionLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => props.theme?.colors?.text?.body || "#5C5C5C"};
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  
  &:hover {
    color: ${(props) => props.theme?.colors?.primary || "#1976d2"};
  }
`;

